import {useEffect,useMemo} from 'react'
import * as THREE from 'three'
import {arenaSkyPreset} from './arenaSkyBackgroundEngine'
import {SCENARIO_FAMILY_BY_ARENA} from './generatedWorldExpansion'
const VERTEX = 'varying vec3 vDir;void main(){vDir=position;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}'
const FRAGMENT = [
 'uniform vec3 horizon;uniform vec3 middle;uniform vec3 zenith;varying vec3 vDir;',
 'void main(){float h=normalize(vDir).y;float upper=smoothstep(-0.15,0.55,h);',
 'vec3 c=mix(horizon,middle,upper);c=mix(c,zenith,smoothstep(0.38,0.95,h));',
 'gl_FragColor=vec4(c,1.0);}'
].join('')
export function ArenaSkyDome({arenaId}:{arenaId:string}){
 const family=SCENARIO_FAMILY_BY_ARENA[arenaId]??arenaId
 const p=arenaSkyPreset(family)
 const material=useMemo(()=>new THREE.ShaderMaterial({
  vertexShader:VERTEX,fragmentShader:FRAGMENT,side:THREE.BackSide,depthWrite:false,
  uniforms:{horizon:{value:new THREE.Color(p.gradient[2])},middle:{value:new THREE.Color(p.gradient[1])},zenith:{value:new THREE.Color(p.gradient[0])}}
 }),[p])
 useEffect(()=>()=>material.dispose(),[material])
 return <mesh name="inyron-sky-dome" scale={110} frustumCulled={false}><sphereGeometry args={[1,32,20]}/><primitive object={material} attach="material"/></mesh>
}
